import { MutationTree } from 'vuex';
import { State } from './state';
import { FormMutationTypes as MutationTypes } from './mutation-types';
 
export type Mutations<S = State> = {
  [MutationTypes.SET_CURRENT_TAB](state: S, payload: number): void;
  [MutationTypes.LOAD_CONFIG](state: S, payload: boolean): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_CURRENT_TAB](state: State, payload: number) {
    state.currentTab = payload;
    log(MutationTypes.SET_CURRENT_TAB, payload)
  },
  [MutationTypes.LOAD_CONFIG](state: State, payload: boolean) {
    state.loadConfig = payload;
    log(MutationTypes.LOAD_CONFIG, payload)
  },
};

const log = (mut: MutationTypes, msg: any) => {
  console.log(mut + ' ' + msg)
}

